// eslint-disable-next-line no-restricted-imports
import { LicenseFragment } from 'api/generated/graphql';
import { LegalClientLicenseInfoEntity } from 'api/types/entity';
import { lodash } from 'helpers';
import { Maybe } from 'types/maybe';

import { parseFileEntity } from '../../helpers';

export const parseLegalClientLicenses = (
  licenses?: Maybe<LicenseFragment>[] | null
): LegalClientLicenseInfoEntity[] | undefined => {
  if (!licenses) {
    return undefined;
  }

  return lodash.compact(licenses).map((licenseInfo) => ({
    activityType: licenseInfo.activityType,
    files: lodash.compact(licenseInfo.files).map(parseFileEntity),
    issueDate: new Date(licenseInfo.issueDate),
    issuingAuthority: licenseInfo.issuingAuthority,
    licenseNumber: licenseInfo.licenseNumber,
    expirationDate: licenseInfo.expirationDate
      ? new Date(licenseInfo.expirationDate)
      : undefined,
  }));
};
